import { Formik } from 'formik';
import React, { useState, useEffect } from 'react';
import * as Yup from "yup";
import { CallApiGet, CallApiPost } from '../../apicalls/calls';
import Paginate from '../Parts/Paginate';

const MisCapturasModal = ({ UsuarioS, is_captura }) => {

    const [Tabla, setTabla] = useState([]);
    // const [Filtros, setFiltros] = useState({});
    // const [Cantidad, setCantidad] = useState({});
    const [filterValues, setFilterValues] = useState({
        f_inicio: "",
        f_fin: ""
    });
    const [sorteos, setSorteos] = useState([]);

    //Paginacion
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const itemsPerPage = 15;

    const validationSchema = Yup.object({
        sorteo: Yup.string().required('El sorteo es requerido')
    });

    const Filter = async () => {
        $("#backdrop").show();
        let params = { ...filterValues };
        params.id_usuario = UsuarioS.user.id;
        params.estatus = "ALL";
        CallApiGet('getSorteos', params, UsuarioS.access_token).then((e)=>{
            setSorteos(e.success.sorteos);
        });
        
        $("#backdrop").hide();
    }

    const submitForm = async (values) => {
        $("#backdrop").show();
        var params = { id_sorteo: values.sorteo, nombre: values.numero, usuario: UsuarioS.user.id, usuario_tipo: UsuarioS.user.tipo_usuario };
        // setFiltros(params);
        const Call = await CallApiGet('getRegistros', params, UsuarioS.access_token);
        // console.log(Call)
        if (Call.status != 200) {
            $("#backdrop").hide();
            window.Swal.fire({
                icon: 'error',
                title: 'Error',
                text: Call.error.message,
            });
        } else {
            setTabla(Call.success.captura);
            //paginacion
            const endOffset = itemOffset + itemsPerPage;
            setCurrentItems(Call.success.captura.slice(itemOffset, endOffset));
            setPageCount(Math.ceil(Call.success.captura.length / itemsPerPage));
            //actions.resetForm();
            $("#backdrop").hide();
        }
    }

    const OpenEdit = (item) => {
        setCantidad(item);
        $('#addSorteo').modal('show');
    }

    // const Edit = async (values, actions) => {
    //     $("#backdrop").show();
    //     $('#addSorteo').modal('hide');
    //     var params = { id_sorteo: id_sorteo, id: values.id, tipo: 1, cantidad: values.cantidad };
    //     //setFiltros(params);
    //     const Call = await CallApiPost('accionesRegistros', params, UsuarioS.access_token);
    //     if (Call.status != 200) {
    //         window.Swal.fire({
    //             icon: 'error',
    //             title: 'Error',
    //             text: Call.error.message,
    //         });
    //     } else {
    //         const Call = await CallApiGet('getRegistros', Filtros, UsuarioS.access_token);
    //         if (Call.status != 200) {
    //             window.Swal.fire({
    //                 icon: 'error',
    //                 title: 'Error',
    //                 text: Call.error.message,
    //             });
    //         } else {
    //             setTabla(Call.success.captura);
    //             const endOffset = itemOffset + itemsPerPage;
    //             setCurrentItems(Call.success.captura.slice(itemOffset, endOffset));
    //             setPageCount(Math.ceil(Call.success.captura.length / itemsPerPage));
    //             //actions.resetForm();
    //         }
    //     }
    // }

    // const Delete = (id) => {
    //     window.Swal.fire({
    //         title: `¿Está seguro de eliminar el registro?`,
    //         icon: 'warning',
    //         showCancelButton: true,
    //         confirmButtonColor: '#3085d6',
    //         cancelButtonColor: '#d33',
    //         confirmButtonText: 'Aceptar',
    //         cancelButtonText: 'Cancelar',
    //     }).then(async (result) => {
    //         if (result.isConfirmed) {
    //             var params = { id_sorteo: id_sorteo, id: id, tipo: 2 };
    //             const Call = await CallApiPost('accionesRegistros', params, UsuarioS.access_token);
    //             if (Call.status != 200) {
    //                 window.Swal.fire({
    //                     icon: 'error',
    //                     title: 'Error',
    //                     text: Call.error.message,
    //                 });
    //             } else {
    //                 const Call = await CallApiGet('getRegistros', Filtros, UsuarioS.access_token);
    //                 if (Call.status != 200) {
    //                     window.Swal.fire({
    //                         icon: 'error',
    //                         title: 'Error',
    //                         text: Call.error.message,
    //                     });
    //                 } else {
    //                     setTabla(Call.success.captura);
    //                     const endOffset = itemOffset + itemsPerPage;
    //                     setCurrentItems(Call.success.captura.slice(itemOffset, endOffset));
    //                     setPageCount(Math.ceil(Call.success.captura.length / itemsPerPage));

    //                     //actions.resetForm();
    //                 }
    //             }
    //         }

    //     });
    // }

    const closeMisCapturasModal = () => $('#mis-capturas').modal('hide');

    useEffect(() => {
        $("#backdrop").hide();
    }, [Tabla]);

    useEffect(() => {
        // Fetch items from another resources.
        const endOffset = itemOffset + itemsPerPage;
        //console.log(`Loading items from ${itemOffset} to ${endOffset}`);
        setCurrentItems(Tabla.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(Tabla.length / itemsPerPage));
    }, [itemOffset, itemsPerPage]);

    const handlePageClick = (e) => {
        const newOffset = (e.selected * itemsPerPage) % Tabla.length;
        setItemOffset(newOffset);
    };

    // Número, Fecha Inicio, Fecha Fin Select Sorteo;

    useEffect(() => {
        if (filterValues.f_inicio || filterValues.f_fin) {
            Filter();
        }
    }, [filterValues]);

    useEffect(() => {
        Filter();
    }, []);


    return (
        <div className="modal fade" id="mis-capturas" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-xl" style={{ maxWidth: "80vw" }} role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Mis capturas</h5>
                        <button type="button" onClick={closeMisCapturasModal} className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <Formik
                            initialValues={{
                                numero: '',
                                f_inicio: "",
                                f_fin: "",
                                sorteo: ''
                            }}
                            validationSchema={validationSchema}
                            enableReinitialize="true"
                            onSubmit={submitForm}
                        >
                            {({
                                values,
                                errors,
                                handleChange,
                                handleSubmit,
                            }) => <form onSubmit={handleSubmit} autoComplete="off" >
                                    <div className='row'>
                                        <div className="col-sm-3 col-md-3 col-lg-3">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Número:</label>
                                                <input
                                                    type="text"
                                                    name='numero'
                                                    className='form-control form-control-sm'
                                                    value={values.numero}
                                                    onChange={handleChange}
                                                />
                                                <span className="help-block">{errors.numero}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-2 col-md-2 col-lg-2">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Fecha Inicio:</label>
                                                <input
                                                    type="date"
                                                    name='f_inicio'
                                                    className='form-control form-control-sm'
                                                    value={values.f_inicio}
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        setFilterValues({
                                                            ...filterValues,
                                                            f_inicio: e.target.value
                                                        });
                                                    }}
                                                // onBlur={handleBlur}
                                                />
                                                <span className="help-block">{errors.f_inicio}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-2 col-md-2 col-lg-2">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Fecha Fin:</label>
                                                <input
                                                    type="date"
                                                    name='f_fin'
                                                    className='form-control form-control-sm'
                                                    value={values.f_fin}
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        setFilterValues({
                                                            ...filterValues,
                                                            f_fin: e.target.value
                                                        });
                                                    }}
                                                // onBlur={handleBlur}
                                                />
                                                <span className="help-block">{errors.f_fin}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-3 col-md-3 col-lg-3">
                                            <div className="form-group">
                                                <label htmlFor="exampleInputEmail1">Sorteo:</label>
                                                <select
                                                    name="sorteo"
                                                    id="sorteo"
                                                    className='form-select form-select-sm'
                                                    value={values.sorteo}
                                                    onChange={handleChange}
                                                >
                                                    <option value="">Seleccione uno</option>
                                                    {
                                                        sorteos.length > 0 && sorteos.map((sorteo, index) => {
                                                            return (
                                                                <option key={index} value={sorteo.id}>{sorteo.nombre}</option>
                                                            )
                                                        })
                                                    }
                                                </select>
                                                <span className="help-block">{errors.sorteo}</span>
                                            </div>
                                        </div>
                                        <div className="col-sm-2 col-md-2 col-lg-2">
                                            <div className="form-group" style={{ paddingTop: '30px' }}>
                                                <button type='submit' className='btn btn-sm mt-30 text-white' style={{ background: "#E6453B" }}>Buscar</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            }
                        </Formik>
                        <div className='table-responsive'>
                            <table className="table table-bordered" id="dataTable" width="100%" cellSpacing="0">
                                <thead>
                                    <tr>
                                        <th>Número</th>
                                        <th>Cantidad</th>
                                        <th>Tipo</th>
                                        <th>Fecha</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentItems.length == 0 && (
                                        <tr className='text-center'>
                                            <td colSpan={7}>No hay registros en la tabla</td>
                                        </tr>
                                    )}
                                    {currentItems && currentItems.map((item, key) => (
                                        <tr key={key}>
                                            <td>{item.numero}</td>
                                            <td>{item.cantidad}</td>
                                            <td>{item.sorteo_tipo == 1 ? 'Primer lugar' : 'Segundo lugar'}</td>
                                            <td>{item.fecha_hora_captura != null ? window.moment(item.fecha_hora_captura).format('YYYY-MM-DD HH:mm:ss') : item.fecha_captura}</td>
                                            {/* <td className="text-center">
                                                {!is_captura ?? <a className="btn btn-danger btn-circle btn-sm" onClick={() => Delete(item.id)} data-bs-toggle="tooltip" data-bs-placement="top" title="Eliminar captura" ><i className="fa fa-times"></i></a>}
                                                <a className="btn btn-success btn-circle btn-sm" onClick={() => OpenEdit(item)} data-bs-toggle="tooltip" data-bs-placement="top" title="Editar captura" ><i className="fa fa-file-signature"></i></a>
                                            </td> */}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className='float-md-right'>
                            <Paginate handlePageClick={handlePageClick} pageCount={pageCount} />
                        </div>
                        {/* <RegistrosModal id_sorteo={id_sorteo} UsuarioS={UsuarioS} is_captura={true} /> */}
                    </div>
                    <div className="modal-footer">
                        <button type="button" onClick={closeMisCapturasModal} className="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MisCapturasModal;